module.exports = __webpack_public_path__ + "img/pref.2f0fbef2.gif";